<template>
  <action :onAction="manageUserAction">
    <template v-slot:icon><v-icon>$vuetify.icons.wordpress</v-icon></template>
    <template v-slot:tooltip><span>Manage the User in WordPress.</span></template>
    <template v-slot:label><span>Manage User</span></template>
  </action>
</template>

<script>
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import Action from '@/components/action/Action.vue';

@Component({
  components: {
    Action,
  },
})
export default class EditUserAction extends Action {
  @Prop(Object) user;

  manageUserAction() {
    const url = `http://thecornerstonescripturestudy.org/wordpress/wp-admin/users.php?s=${this.user.email}`;
    window.open(url, '_blank');
  }
}
</script>
